<template>
  <div id="itembank">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="{path: '/content/itembank'}">Content</router-link></li>
      <li class="active">Import Itembank Gratis</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Import Itembank</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Import Itembank</h4>
          </div>
          <div class="panel-body" style="display:flex; flex-flow:column;">
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-danger fade in m-b-15" v-if="errorParse">
                  <span class="close" data-dismiss="alert">&times;</span>
                  <strong>Terjadi kesalahan!</strong>
                  <ul style="text-decoration:none;" >
                  <li>File tidak bisa dibaca</li>
                  <li>Pastikan jenis file (.JSON / .json)</li>
                  <li>Format JSON tidak valid</li>
                  <li>Atau <a href="https://codebeautify.org/jsonviewer" style="color:red;text-decoration:revert;" target="_blank">Periksa text JSON anda disini</a></li>
                </ul>
                </div>
              </div>
              <div class="col-md-4" style="display:flex;align-items:flex-start;">Upload File JSON</div>
              <div class="col-md-4">
                <input type="file" ref="file" style="display: none" @change="onFileChange()">
                <button type="button" style="max-width:200px; margin-bottom:10px;" class="btn btn-info btn-md" @click="$refs.file.click()"><span class="fa fa-file"></span> Pilih File JSON</button>
                <br/>
                <span>Masukkan file dalam format JSON</span>
              </div>
              <div class="col-md-4">
                <button type="button" :disabled="itembanks.length > 0" style="max-width:200px;" class="btn btn-info btn-md pull-right" v-if="!isReadable" @click="previewJSON()"><span class="fa fa-table"></span> Preview</button>
              </div>
            </div>
            <div class="row" v-if="itembanks.length > 0">
              <div class="col-md-1">
               <b> Mapel : </b>
              </div>
              <div class="col-md-6">
                <b>{{viewMapel}}</b>
              </div>
            </div>
            <div class="row" v-if="itembanks.length > 0">
              <div class="col-md-1">
                <b>Jenjang: </b>
              </div>
              <div class="col-md-6">
                <b>{{viewJenjang}}</b>
              </div>
            </div>
            <div style="padding-top:20px; padding-bottom:10px;" v-if="itembanks.length > 0">
              <app-datatable 
                :items="itembanks" 
                :headers="headers" 
                :has-action="true"
                :has-custom-pagination="false"
                :has-custom-search="false"
                :has-search-power="false"
                v-on:deleted="deleteItem($event)"
              />
              
              <button type="button" style="max-width:300px; float:right; margin:10px;" class="btn btn-success btn-md" @click="submitImport()"><span class="fa fa-download"></span> Import</button>
              <button type="button" style="max-width:300px; float:right; margin:10px;" class="btn btn-success btn-md" @click="cancelImport()"><span class="fa fa-close"></span> Batal</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import ContentService from '@/services/content.js'
import DataTable from '@/components/plugins/DataTable'
import Moment from 'moment'
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'
export default {
	name: 'tryout',
	components: {
    'app-datatable': DataTable,
    'app-spinner': Spinner,
		'app-modal': Modal
	},
	data: function () {
		return {
      isLoading: false,
			itembanks: [],
			selectedRow: null,
			search: null,
			exportModal: false,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Isi', 'Kelas'],
      headersKey: ['isi', 'grade'], // camel case for matching search with API
      
      isReadable: true,
      errorParse: false,
      previewJSONData: [],
      importFile: null,
      viewJenjang: null,
      viewMapel: null
		}
	},
	watch: {
		pagination: function () {
		},
	},
	mounted: function () {
	},
	methods: {
		fetchData: function (data) {
      try {
        var item = data
        var context = this
        context.tryouts = []
        item.forEach(function (soal) {
          context.viewJenjang = soal.grades[0].jenjang.nama
          context.viewMapel = soal.mapel.nama
          var kelas = []
          var count = 0
          var jenjang = ''
          soal.grades.forEach(function (grade) {
            kelas.push(grade.grade)
            jenjang = grade.jenjang.nama
          })
          var row = {
            index: soal.id,
            data: [
              soal.isi.substr(0,100) + '...',
              kelas
            ]
          }
          context.itembanks.push(row)
        })
      } catch (e) {
        alert('Preview data tidak bisa dilakukan, mohon periksa kembali data kamu')
      }
    },
    submitImport() {
      this.isLoading = true
      var context = this
      let formData = this.previewJSONData
      ContentService.importItems(formData ,function (result){
        context.isLoading = false
        if(result.success){
          alert('Berhasil diupload')
          context.$router.push('/content/itembank?mapel=1')
        } else {
          alert('Gagal Upload')
        }
      })     
    },
    previewJSON: function () {
      this.fetchData(this.previewJSONData)
    },
    onFileChange: function (e) {
      let files = this.$refs.file.files;
      if (!files.length) return;
      this.importFile = files[0]
      this.readFile(files[0]);
    },
    readFile(file) {
      let reader = new FileReader();
      reader.onload = e => {
         try {
            this.previewJSONData = JSON.parse(e.target.result);
            this.isReadable = false
            this.errorParse = false
            this.tryouts = []
          } catch (e) {
            this.isReadable = true
            this.errorParse = true
            this.tryouts = []
          }
      }
      reader.readAsText(file)
    },
		createTryout: function () {
			this.$store.commit('tryout_reset')
			this.$router.push({ path: '/tryout-form' })
		},
		importTryout: function () {
			this.$router.push({ path: '/tryout-import' })
		},
		exportTryout: function () {
			this.$router.push({ path: '/tryout-export' })
		},
    cancelImport: function () {
      this.itembanks = []
      this.isReadable = true
      this.importFile = null
      const input = this.$refs.file
      input.type = 'text'
      input.type = 'file'
    },
    deleteItem: function (content) {
			var confirmed = window.confirm("Apakah anda yakin akan menghapus Soal Gratis ini?")
			if (confirmed) {
        for(var i = 0; i < this.previewJSONData.length; i++){
          if(this.previewJSONData[i].id === content.index){
            this.previewJSONData.splice(i, 1)
            alert('Data berhasil dihapus')
          }
        }
        this.itembanks = []
        this.fetchData(this.previewJSONData)
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// ItemBankImport.vue?13006da8